import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=11ffb785&"
import script from "./group-list.vue?vue&type=script&lang=js&"
export * from "./group-list.vue?vue&type=script&lang=js&"
import style0 from "./group-list.vue?vue&type=style&index=0&id=11ffb785&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports